<template>
  <div class="shopping-step1-container">
    <!-- {{ this.cartData }} -->
    <ul class="shopping-table mb-3">
      <li class="shopping-table-header d-flex">
        <div>商品資訊</div>
        <div>價格</div>
        <div>數量</div>
        <div>操作</div>
      </li>
      <li
        class="shopping-table-tr d-flex"
        v-for="data in tableData"
        :key="data.product.id"
      >
        <div>{{ data.product.title }}</div>
        <div>{{ $money(data.product.price * data.quantity) }}</div>
        <div>
          <el-select
            placeholder="請選擇數量"
            v-model="data.quantity"
            @change="changeProductNumHandler(data)"
          >
            <el-option
              v-for="index in 100"
              :key="index"
              :label="index"
              :value="index"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <el-button
            size="mini"
            type="danger"
            @click="productDelHandler(data.product.id)"
            >删除</el-button
          >
        </div>
      </li>
    </ul>
    <div class="mb-3">
      <span class="mr-3"> 總金額:{{ $money(total) }} </span>
      <el-button size="mini" type="danger" @click="productDelAllHandler"
        >删除全部</el-button
      >
    </div>
    <div class="d-flex justify-content-end">
      <el-button class="mr-3" @click="next">下一步</el-button>
    </div>
  </div>
</template>

<script>
import apiFrontCart from '@/assets/js/api/front/apiFrontCart';
import { mapActions } from 'vuex';

export default {
  created() {
    this.$emit('insideChangeActive', 1);
    this.initTableDataHandler();
  },
  data() {
    return {
      total: 0,
      tableData: [],
    };
  },
  methods: {
    ...mapActions(['setCartLength']),
    next() {
      this.$emit('insideNext');
    },
    initTableDataHandler() {
      apiFrontCart
        .get('')
        .then(res => {
          this.tableData = res.data.data;
          this.total = res.data.data.reduce((pre, cur) => {
            return pre + cur.product.price * cur.quantity;
          }, 0);
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
    changeProductNumHandler(data) {
      let { quantity } = data;
      let { id } = data.product;
      apiFrontCart
        .patch('', {
          product: id,
          quantity: quantity,
        })
        .then(res => {
          if (res.status === 200) {
            this.initTableDataHandler();
            this.$fire({
              title: `更新成功`,
              type: 'success',
              timer: 3000,
            });
          }
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
    productDelHandler(id) {
      apiFrontCart
        .delete(id)
        .then(res => {
          if (res.status === 200) {
            this.initTableDataHandler();
            this.setCartLength();
            this.$fire({
              title: `刪除成功`,
              type: 'success',
              timer: 3000,
            });
          }
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
    productDelAllHandler() {
      apiFrontCart
        .delete('/all/product')
        .then(res => {
          if (res.status === 200) {
            this.$fire({
              title: `刪除成功`,
              type: 'success',
              timer: 3000,
            });
            this.initTableDataHandler();
            this.setCartLength();
          }
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
